import {
  CancelOrderRequest,
  GetInfoForBookingRequest,
  GetOrderByOrderNumberRequest,
  OrderInfoDto,
  OrdersApi,
  PreorderBookingDetailsInfoResponseDto,
  SubmitBookingInfoRequest,
  SubmitPersonalInfoRequest,
  SubmitPersonalInfoResponseDto,
} from '@/api/generated/fetch-client';
import { WithSignal } from '@/types/typings';

export class OrderApi {
  constructor(private readonly ordersApi: OrdersApi) {}

  async getInfoForBooking(
    requestParameters: WithSignal<GetInfoForBookingRequest>,
  ): Promise<PreorderBookingDetailsInfoResponseDto> {
    const { signal, ...args } = requestParameters;
    return this.ordersApi.getInfoForBooking(args, { signal });
  }

  async submitBookingInfo(requestParameters: SubmitBookingInfoRequest) {
    return await this.ordersApi.submitBookingInfo(requestParameters);
  }

  async submitPersonalInfo(
    requestParameters: WithSignal<SubmitPersonalInfoRequest>,
  ): Promise<SubmitPersonalInfoResponseDto> {
    const { signal, ...args } = requestParameters;
    return this.ordersApi.submitPersonalInfo(args, { signal });
  }

  async getOrderInfoByOrderNumber(
    requestParameters: WithSignal<GetOrderByOrderNumberRequest>,
  ): Promise<OrderInfoDto> {
    const { signal, ...args } = requestParameters;
    return this.ordersApi.getOrderByOrderNumber(args, { signal });
  }

  async checkOrderExistsByOrderNumber(
    args: GetOrderByOrderNumberRequest,
  ): Promise<OrderInfoDto> {
    return this.ordersApi.getOrderByOrderNumber(args);
  }

  async cancelOrder(requestParameters: CancelOrderRequest) {
    return await this.ordersApi.cancelOrder(requestParameters);
  }
}
